// data/languages/peul/categories/grammaire.ts

import { GrammarCategory } from '../../../../types/types';

export const grammaire: GrammarCategory = {

  // ============================================================
  // UNITÉ 1 — PRONOMS, CLASSES NOMINALES & STRUCTURE
  // ============================================================

  'Pronoms personnels (ɗon)': {
    'Miɗo yaha': {
      translation: "Je vais (en train de)",
      translationEn: "I am going (in the process of)",
      explanation: "Présent progressif 1re personne du singulier. 'Miɗo' est le marqueur de focus progressif.",
      explanationEn: "Progressive present, 1st person singular. 'Miɗo' is the progressive focus marker.",
      example: "Miɗo yaha to luumo. (Je suis en train d'aller au marché.)",
      exampleEn: "Miɗo yaha to luumo. (I am going to the market.)"
    },
    'Aɗa yaha': {
      translation: "Tu vas (en train de)",
      translationEn: "You are going (in the process of)",
      explanation: "Présent progressif 2e personne du singulier.",
      explanationEn: "Progressive present, 2nd person singular.",
      example: "Aɗa yaha to lekkol. (Tu es en train d'aller à l'école.)",
      exampleEn: "Aɗa yaha to lekkol. (You are going to school.)"
    },
    'Omo yaha': {
      translation: "Il/Elle va (en train de)",
      translationEn: "He/She is going (in the process of)",
      explanation: "Présent progressif 3e personne du singulier.",
      explanationEn: "Progressive present, 3rd person singular.",
      example: "Omo yaha to galle. (Il/Elle est en train d'aller à la maison.)",
      exampleEn: "Omo yaha to galle. (He/She is going home.)"
    },
    'Minen ɗon yaha': {
      translation: "Nous allons (en train de)",
      translationEn: "We are going (in the process of)",
      explanation: "Présent progressif 1re personne du pluriel. 'ɗon' est le marqueur progressif pluriel.",
      explanationEn: "Progressive present, 1st person plural. 'ɗon' is the plural progressive marker.",
      example: "Minen ɗon yaha to luumo. (Nous sommes en train d'aller au marché.)",
      exampleEn: "Minen ɗon yaha to luumo. (We are going to the market.)"
    },
    'Onon ɗon yaha': {
      translation: "Vous allez (en train de)",
      translationEn: "You (pl.) are going (in the process of)",
      explanation: "Présent progressif 2e personne du pluriel.",
      explanationEn: "Progressive present, 2nd person plural.",
      example: "Onon ɗon yaha to lekkol. (Vous êtes en train d'aller à l'école.)",
      exampleEn: "Onon ɗon yaha to lekkol. (You (pl.) are going to school.)"
    },
    'ɓe ɗon yaha': {
      translation: "Ils/Elles vont (en train de)",
      translationEn: "They are going (in the process of)",
      explanation: "Présent progressif 3e personne du pluriel.",
      explanationEn: "Progressive present, 3rd person plural.",
      example: "ɓe ɗon yaha to galle. (Ils/Elles sont en train d'aller à la maison.)",
      exampleEn: "ɓe ɗon yaha to galle. (They are going home.)"
    },
  },

  'Pronoms emphatiques': {
    'Miin': {
      translation: "Moi (emphatique)",
      translationEn: "Me (emphatic)",
      explanation: "Pronom emphatique 1re personne du singulier, utilisé pour insister sur le sujet.",
      explanationEn: "Emphatic pronoun, 1st person singular, used to stress the subject.",
      example: "Miin mi waɗii ko. (C'est moi qui l'ai fait.)",
      exampleEn: "Miin mi waɗii ko. (It's me who did it.)"
    },
    'Aan': {
      translation: "Toi (emphatique)",
      translationEn: "You (emphatic)",
      explanation: "Pronom emphatique 2e personne du singulier.",
      explanationEn: "Emphatic pronoun, 2nd person singular.",
      example: "Aan naa wii mi. (C'est toi qui m'as appelé.)",
      exampleEn: "Aan naa wii mi. (It's you who called me.)"
    },
    'Kanko': {
      translation: "Lui/Elle (emphatique)",
      translationEn: "Him/Her (emphatic)",
      explanation: "Pronom emphatique 3e personne du singulier.",
      explanationEn: "Emphatic pronoun, 3rd person singular.",
      example: "Kanko o yahii. (C'est lui/elle qui est parti(e).)",
      exampleEn: "Kanko o yahii. (It's him/her who left.)"
    },
    'Kaminen': {
      translation: "Nous (emphatique)",
      translationEn: "Us (emphatic)",
      explanation: "Pronom emphatique 1re personne du pluriel.",
      explanationEn: "Emphatic pronoun, 1st person plural.",
      example: "Kaminen min nanii. (C'est nous qui avons compris.)",
      exampleEn: "Kaminen min nanii. (It's us who understood.)"
    },
    'Kamonon': {
      translation: "Vous (emphatique)",
      translationEn: "You (pl., emphatic)",
      explanation: "Pronom emphatique 2e personne du pluriel.",
      explanationEn: "Emphatic pronoun, 2nd person plural.",
      example: "Kamonon onon wii. (C'est vous qui avez dit cela.)",
      exampleEn: "Kamonon onon wii. (It's you (pl.) who said that.)"
    },
    'Kamɓe': {
      translation: "Eux/Elles (emphatique)",
      translationEn: "Them (emphatic)",
      explanation: "Pronom emphatique 3e personne du pluriel.",
      explanationEn: "Emphatic pronoun, 3rd person plural.",
      example: "Kamɓe ɓe yahii. (Ce sont eux/elles qui sont parti(e)s.)",
      exampleEn: "Kamɓe ɓe yahii. (It's them who left.)"
    },
  },

  'Pronoms objets': {
    '-am': {
      translation: "Me/Moi (objet)",
      translationEn: "Me (object)",
      explanation: "Suffixe objet 1re personne du singulier, attaché au verbe.",
      explanationEn: "Object suffix, 1st person singular, attached to the verb.",
      example: "Dimmal-am. (Aide-moi.)",
      exampleEn: "Dimmal-am. (Help me.)"
    },
    '-ma': {
      translation: "Te/Toi (objet)",
      translationEn: "You (object)",
      explanation: "Suffixe objet 2e personne du singulier.",
      explanationEn: "Object suffix, 2nd person singular.",
      example: "Mi yeɗii-ma. (Je t'ai vu.)",
      exampleEn: "Mi yeɗii-ma. (I saw you.)"
    },
    '-mo': {
      translation: "Le/La/Lui (objet)",
      translationEn: "Him/Her/It (object)",
      explanation: "Suffixe objet 3e personne du singulier.",
      explanationEn: "Object suffix, 3rd person singular.",
      example: "Mi rokki-mo. (Je lui ai donné.)",
      exampleEn: "Mi rokki-mo. (I gave to him/her.)"
    },
    '-min': {
      translation: "Nous (objet)",
      translationEn: "Us (object)",
      explanation: "Suffixe objet 1re personne du pluriel.",
      explanationEn: "Object suffix, 1st person plural.",
      example: "Noddu-min. (Appelle-nous.)",
      exampleEn: "Noddu-min. (Call us.)"
    },
    '-on': {
      translation: "Vous (objet)",
      translationEn: "You (pl., object)",
      explanation: "Suffixe objet 2e personne du pluriel.",
      explanationEn: "Object suffix, 2nd person plural.",
      example: "Mi yeɗii-on. (Je vous ai vus.)",
      exampleEn: "Mi yeɗii-on. (I saw you (pl.).)"
    },
    '-ɓe': {
      translation: "Les/Leur (objet, personnes)",
      translationEn: "Them (object, people)",
      explanation: "Suffixe objet 3e personne du pluriel pour les personnes.",
      explanationEn: "Object suffix, 3rd person plural, for people.",
      example: "Mi wii-ɓe. (Je leur ai parlé.)",
      exampleEn: "Mi wii-ɓe. (I spoke to them.)"
    },
  },

  'Pronoms possessifs': {
    'am': {
      translation: "Mon/Ma",
      translationEn: "My",
      explanation: "Possessif 1re personne du singulier, placé après le nom.",
      explanationEn: "Possessive, 1st person singular, placed after the noun.",
      example: "Galle am. (Ma maison.)",
      exampleEn: "Galle am. (My house.)"
    },
    'maa': {
      translation: "Ton/Ta",
      translationEn: "Your",
      explanation: "Possessif 2e personne du singulier.",
      explanationEn: "Possessive, 2nd person singular.",
      example: "Galle maa. (Ta maison.)",
      exampleEn: "Galle maa. (Your house.)"
    },
    'makko': {
      translation: "Son/Sa",
      translationEn: "His/Her",
      explanation: "Possessif 3e personne du singulier.",
      explanationEn: "Possessive, 3rd person singular.",
      example: "Galle makko. (Sa maison.)",
      exampleEn: "Galle makko. (His/Her house.)"
    },
    'amen': {
      translation: "Notre",
      translationEn: "Our",
      explanation: "Possessif 1re personne du pluriel.",
      explanationEn: "Possessive, 1st person plural.",
      example: "Galle amen. (Notre maison.)",
      exampleEn: "Galle amen. (Our house.)"
    },
    'mooɗon': {
      translation: "Votre",
      translationEn: "Your (pl.)",
      explanation: "Possessif 2e personne du pluriel.",
      explanationEn: "Possessive, 2nd person plural.",
      example: "Galle mooɗon. (Votre maison.)",
      exampleEn: "Galle mooɗon. (Your (pl.) house.)"
    },
    'maɓɓe': {
      translation: "Leur",
      translationEn: "Their",
      explanation: "Possessif 3e personne du pluriel.",
      explanationEn: "Possessive, 3rd person plural.",
      example: "Galle maɓɓe. (Leur maison.)",
      exampleEn: "Galle maɓɓe. (Their house.)"
    },
  },

  'Pronoms sujets simples': {
    'Mi': {
      translation: "Je",
      translationEn: "I",
      explanation: "Pronom sujet 1re personne du singulier — forme de base utilisée au passé et à l'impératif.",
      explanationEn: "Subject pronoun, 1st person singular — base form used in the past tense and imperative.",
      example: "Mi yahii. (Je suis allé(e).)",
      exampleEn: "Mi yahii. (I went.)",
      audio: "Ff-Mi"
    },
    'A': {
      translation: "Tu",
      translationEn: "You",
      explanation: "Pronom sujet 2e personne du singulier — forme de base.",
      explanationEn: "Subject pronoun, 2nd person singular — base form.",
      example: "A yahii. (Tu es allé(e).)",
      exampleEn: "A yahii. (You went.)",
      audio: "Ff-A"
    },
    'O': {
      translation: "Il/Elle",
      translationEn: "He/She",
      explanation: "Pronom sujet 3e personne du singulier — forme de base.",
      explanationEn: "Subject pronoun, 3rd person singular — base form.",
      example: "O yahii. (Il/Elle est allé(e).)",
      exampleEn: "O yahii. (He/She went.)",
      audio: "Ff-O"
    },
    'Minen': {
      translation: "Nous",
      translationEn: "We",
      explanation: "Pronom sujet 1re personne du pluriel — forme de base.",
      explanationEn: "Subject pronoun, 1st person plural — base form.",
      example: "Minen njahii luumo. (Nous sommes allés au marché.)",
      exampleEn: "Minen njahii luumo. (We went to the market.)"
    },
    'Onon': {
      translation: "Vous",
      translationEn: "You (pl.)",
      explanation: "Pronom sujet 2e personne du pluriel — forme de base.",
      explanationEn: "Subject pronoun, 2nd person plural — base form.",
      example: "Onon njahii lekkol. (Vous êtes allés à l'école.)",
      exampleEn: "Onon njahii lekkol. (You (pl.) went to school.)"
    },
    'ɓe': {
      translation: "Ils/Elles (personnes)",
      translationEn: "They (people)",
      explanation: "Pronom sujet 3e personne du pluriel pour les personnes.",
      explanationEn: "Subject pronoun, 3rd person plural, for people.",
      example: "ɓe njahii galle. (Ils/Elles sont allés à la maison.)",
      exampleEn: "ɓe njahii galle. (They went home.)"
    },
  },

  'Marqueurs de focus (Ko)': {
    'Ko mi': {
      translation: "C'est moi qui",
      translationEn: "It's me who",
      explanation: "'Ko' est la copule de focus. Combiné au pronom, il met en relief le sujet de l'action.",
      explanationEn: "'Ko' is the focus copula. Combined with the pronoun, it highlights the subject of the action.",
      example: "Ko mi waɗiri. (C'est MOI qui l'ai fait — pas quelqu'un d'autre.)",
      exampleEn: "Ko mi waɗiri. (It's ME who did it — not someone else.)"
    },
    'Ko aan': {
      translation: "C'est toi qui",
      translationEn: "It's you who",
      explanation: "Focus sur le sujet 2e personne du singulier.",
      explanationEn: "Focus on the 2nd person singular subject.",
      example: "Ko aan wii nii. (C'est TOI qui as dit ça.)",
      exampleEn: "Ko aan wii nii. (It's YOU who said that.)"
    },
    'Ko kanko': {
      translation: "C'est lui/elle qui",
      translationEn: "It's him/her who",
      explanation: "Focus sur le sujet 3e personne du singulier.",
      explanationEn: "Focus on the 3rd person singular subject.",
      example: "Ko kanko yahata. (C'est LUI/ELLE qui partira.)",
      exampleEn: "Ko kanko yahata. (It's HIM/HER who will leave.)"
    },
    'Ko minen': {
      translation: "C'est nous qui",
      translationEn: "It's us who",
      explanation: "Focus sur le sujet 1re personne du pluriel.",
      explanationEn: "Focus on the 1st person plural subject.",
      example: "Ko minen nannii. (C'est NOUS qui avons compris.)",
      exampleEn: "Ko minen nannii. (It's US who understood.)"
    },
    'Ko onon': {
      translation: "C'est vous qui",
      translationEn: "It's you (pl.) who",
      explanation: "Focus sur le sujet 2e personne du pluriel.",
      explanationEn: "Focus on the 2nd person plural subject.",
      example: "Ko onon waɗiriinoo. (C'est VOUS qui l'aviez fait.)",
      exampleEn: "Ko onon waɗiriinoo. (It's YOU (pl.) who had done it.)"
    },
    'Ko kamɓe': {
      translation: "Ce sont eux/elles qui",
      translationEn: "It's them who",
      explanation: "Focus sur le sujet 3e personne du pluriel.",
      explanationEn: "Focus on the 3rd person plural subject.",
      example: "Ko kamɓe njahata. (Ce sont EUX/ELLES qui partiront.)",
      exampleEn: "Ko kamɓe njahata. (It's THEM who will leave.)"
    },
  },

  'Classes nominales': {
    'Classe O/ɓe (personnes)': {
      translation: "Singulier/Pluriel — personnes",
      translationEn: "Singular/Plural — people",
      explanation: "Classe des êtres humains. Singulier en -o ou -ngo, pluriel en -ɓe. C'est la classe la plus distinctive du peul.",
      explanationEn: "Class of human beings. Singular in -o or -ngo, plural in -ɓe. This is the most distinctive class in Fula.",
      example: "Gorko / Worɓe. (Un homme / Des hommes.) — Debbo / Rewɓe. (Une femme / Des femmes.)",
      exampleEn: "Gorko / Worɓe. (A man / Men.) — Debbo / Rewɓe. (A woman / Women.)"
    },
    'Classe nge/i (grands animaux)': {
      translation: "Singulier/Pluriel — grands animaux",
      translationEn: "Singular/Plural — large animals",
      explanation: "Classe des grands animaux domestiques. Singulier en -nge, pluriel en -i.",
      explanationEn: "Class of large domestic animals. Singular in -nge, plural in -i.",
      example: "Nagge / Na'i. (Une vache / Des vaches.) — Puccu / Pucci. (Un cheval / Des chevaux.)",
      exampleEn: "Nagge / Na'i. (A cow / Cows.) — Puccu / Pucci. (A horse / Horses.)"
    },
    'Classe ndu/ɗi (parties du corps)': {
      translation: "Singulier/Pluriel — parties du corps",
      translationEn: "Singular/Plural — body parts",
      explanation: "Classe des parties du corps et de certains concepts concrets. Singulier en -ndu, pluriel en -ɗi.",
      explanationEn: "Class of body parts and certain concrete concepts. Singular in -ndu, plural in -ɗi.",
      example: "Hoore / Koore. (Une tête / Des têtes.) — Reedu / Reeɗi. (Un ventre / Des ventres.)",
      exampleEn: "Hoore / Koore. (A head / Heads.) — Reedu / Reeɗi. (A belly / Bellies.)"
    },
    'Classe nde/ɗe (objets courants)': {
      translation: "Singulier/Pluriel — objets et lieux",
      translationEn: "Singular/Plural — objects and places",
      explanation: "Classe des objets courants, chambres et espaces. Singulier souvent en -nde, pluriel en -ɗe.",
      explanationEn: "Class of everyday objects, rooms and spaces. Singular often in -nde, plural in -ɗe.",
      example: "Suudu / Cuuɗi. (Une chambre / Des chambres.) — Ngesa / Nyeese. (Un champ / Des champs.)",
      exampleEn: "Suudu / Cuuɗi. (A room / Rooms.) — Ngesa / Nyeese. (A field / Fields.)"
    },
    'Classe ki/gi (végétaux)': {
      translation: "Singulier/Pluriel — arbres et végétaux",
      translationEn: "Singular/Plural — trees and plants",
      explanation: "Classe des végétaux, arbres et objets longs. Singulier en -ki, pluriel en -gi.",
      explanationEn: "Class of plants, trees and long objects. Singular in -ki, plural in -gi.",
      example: "Caaki / Caage. (Un arbre / Des arbres.) — Laawol / Laabi. (Un chemin / Des chemins.)",
      exampleEn: "Caaki / Caage. (A tree / Trees.) — Laawol / Laabi. (A path / Paths.)"
    },
    'Classe ol/le (lieux et institutions)': {
      translation: "Singulier/Pluriel — lieux et institutions",
      translationEn: "Singular/Plural — places and institutions",
      explanation: "Classe des lieux institutionnels et de certains mots empruntés.",
      explanationEn: "Class of institutional places and certain borrowed words.",
      example: "Lekkol / Lekkole. (Une école / Des écoles.) — Luumo / Luume. (Un marché / Des marchés.)",
      exampleEn: "Lekkol / Lekkole. (A school / Schools.) — Luumo / Luume. (A market / Markets.)"
    },
  },

  'Structure de la phrase': {
    'Ordre neutre': {
      translation: "Sujet + Marqueur progressif + Verbe",
      translationEn: "Subject + Progressive marker + Verb",
      explanation: "L'ordre de base en peul : Sujet — Marqueur (miɗo/aɗa/omo...) — Verbe — Complément.",
      explanationEn: "The basic word order in Fula: Subject — Marker (miɗo/aɗa/omo...) — Verb — Complement.",
      example: "Miɗo njoɓa ceede. (Je suis en train de payer — sujet + marqueur + verbe + COD.)",
      exampleEn: "Miɗo njoɓa ceede. (I am paying — subject + marker + verb + direct object.)"
    },
    'Focus sujet (Ko)': {
      translation: "C'est [sujet] qui...",
      translationEn: "It's [subject] who...",
      explanation: "La copule 'ko' précède le pronom emphatique pour mettre en relief QUI fait l'action.",
      explanationEn: "The copula 'ko' precedes the emphatic pronoun to highlight WHO performs the action.",
      example: "Ko miin mi waɗii ko. (C'est MOI qui l'ai fait — pas quelqu'un d'autre.)",
      exampleEn: "Ko miin mi waɗii ko. (It's ME who did it — not someone else.)"
    },
    'Verbe copule (woni)': {
      translation: "Être / C'est",
      translationEn: "To be / It is",
      explanation: "'Woni' est le verbe être en peul, utilisé pour l'identité et la localisation.",
      explanationEn: "'Woni' is the verb 'to be' in Fula, used for identity and location.",
      example: "Mi woni jangirɗo. (Je suis étudiant.)",
      exampleEn: "Mi woni jangirɗo. (I am a student.)"
    },
    'Présentatif (woni ɗoo)': {
      translation: "Voilà / Il/Elle est ici",
      translationEn: "Here is / He/She is here",
      explanation: "'Woni ɗoo' situe quelqu'un dans l'espace immédiat. Équivalent du présentatif français.",
      explanationEn: "'Woni ɗoo' locates someone in the immediate space. Equivalent to the French presentative.",
      example: "O woni ɗoo. (Il/Elle est ici. / Le voilà.)",
      exampleEn: "O woni ɗoo. (He/She is here. / There he/she is.)"
    },
    'Négation par suffixe (-aa)': {
      translation: "Négation par suffixe -aa",
      translationEn: "Negation with the suffix -aa",
      explanation: "La négation du présent habituels se forme en ajoutant '-aa' après la racine verbale.",
      explanationEn: "Negation of the habitual present is formed by adding '-aa' after the verb root.",
      example: "Mi yahaa. (Je ne vais pas.) — Mi janngaa. (Je n'étudie pas.)",
      exampleEn: "Mi yahaa. (I don't go.) — Mi janngaa. (I don't study.)"
    },
    'Coordination (e)': {
      translation: "Et / Avec (coordination)",
      translationEn: "And / With (coordination)",
      explanation: "'E' relie deux noms ou groupes nominaux, comme 'et' en français.",
      explanationEn: "'E' links two nouns or noun phrases, like 'and' in French/English.",
      example: "Gorko e debbo njahii. (L'homme et la femme sont partis.)",
      exampleEn: "Gorko e debbo njahii. (The man and the woman left.)"
    },
  },

  // ============================================================
  // UNITÉ 2 — TEMPS VERBAUX, NÉGATION & QUESTIONS
  // ============================================================

  'Temps verbaux — Présent': {
    'Miɗo yaha': {
      translation: "Je vais (en cours)",
      translationEn: "I am going (in progress)",
      explanation: "Présent progressif 1re personne. Action en train de se dérouler au moment de la parole.",
      explanationEn: "Progressive present, 1st person. Action taking place at the moment of speaking.",
      example: "Miɗo yaha to luumo hannde. (Je vais au marché maintenant.)",
      exampleEn: "Miɗo yaha to luumo hannde. (I am going to the market now.)"
    },
    'Aɗa yaha': {
      translation: "Tu vas (en cours)",
      translationEn: "You are going (in progress)",
      explanation: "Présent progressif 2e personne du singulier.",
      explanationEn: "Progressive present, 2nd person singular.",
      example: "Aɗa yaha to lekkol? (Tu vas à l'école maintenant ?)",
      exampleEn: "Aɗa yaha to lekkol? (Are you going to school now?)"
    },
    'Omo yaha': {
      translation: "Il/Elle va (en cours)",
      translationEn: "He/She is going (in progress)",
      explanation: "Présent progressif 3e personne du singulier.",
      explanationEn: "Progressive present, 3rd person singular.",
      example: "Omo yaha to galle. (Il/Elle va à la maison maintenant.)",
      exampleEn: "Omo yaha to galle. (He/She is going home now.)"
    },
    'Mi jangay': {
      translation: "J'étudie (habituellement)",
      translationEn: "I study (habitually)",
      explanation: "Présent habituel 1re personne. Le suffixe '-ay' indique une action régulière ou un état permanent.",
      explanationEn: "Habitual present, 1st person. The suffix '-ay' indicates a regular action or a permanent state.",
      example: "Mi jangay perol kala lewru. (J'étudie le peul chaque mois.)",
      exampleEn: "Mi jangay perol kala lewru. (I study Fula every month.)"
    },
    'O waɗa': {
      translation: "Il/Elle fait (habituellement)",
      translationEn: "He/She does (habitually)",
      explanation: "Présent habituel 3e personne du singulier — action répétée ou état permanent.",
      explanationEn: "Habitual present, 3rd person singular — repeated action or permanent state.",
      example: "O waɗa ko baawi. (Il/Elle fait ce qu'il/elle peut.)",
      exampleEn: "O waɗa ko baawi. (He/She does what he/she can.)"
    },
    'Miɗo anndi': {
      translation: "Je sais / Je connais",
      translationEn: "I know",
      explanation: "Présent d'état avec le verbe cognitif 'anndi' (savoir/connaître).",
      explanationEn: "State present with the cognitive verb 'anndi' (to know).",
      example: "Miɗo anndi innde maa. (Je connais ton nom.)",
      exampleEn: "Miɗo anndi innde maa. (I know your name.)"
    },
  },

  'Temps verbaux — Passé': {
    'Mi yahii': {
      translation: "Je suis allé(e)",
      translationEn: "I went",
      explanation: "Passé accompli 1re personne. Le suffixe '-ii' marque l'action accomplie en peul.",
      explanationEn: "Perfective past, 1st person. The suffix '-ii' marks the completed action in Fula.",
      example: "Mi yahii to luumo démb. (Je suis allé(e) au marché hier.)",
      exampleEn: "Mi yahii to luumo démb. (I went to the market yesterday.)"
    },
    'A yahii': {
      translation: "Tu es allé(e)",
      translationEn: "You went",
      explanation: "Passé accompli 2e personne du singulier.",
      explanationEn: "Perfective past, 2nd person singular.",
      example: "A yahii to lekkol démb? (Tu es allé(e) à l'école hier ?)",
      exampleEn: "A yahii to lekkol démb? (Did you go to school yesterday?)"
    },
    'O yahii': {
      translation: "Il/Elle est allé(e)",
      translationEn: "He/She went",
      explanation: "Passé accompli 3e personne du singulier.",
      explanationEn: "Perfective past, 3rd person singular.",
      example: "O yahii to galle. (Il/Elle est allé(e) à la maison.)",
      exampleEn: "O yahii to galle. (He/She went home.)"
    },
    'Minen njahii': {
      translation: "Nous sommes allé(e)s",
      translationEn: "We went",
      explanation: "Passé accompli 1re personne du pluriel. Le préfixe 'nj-' marque la nasalisation au pluriel.",
      explanationEn: "Perfective past, 1st person plural. The prefix 'nj-' marks nasalization in the plural.",
      example: "Minen njahii to luumo démb. (Nous sommes allé(e)s au marché hier.)",
      exampleEn: "Minen njahii to luumo démb. (We went to the market yesterday.)"
    },
    'Onon njahii': {
      translation: "Vous êtes allé(e)s",
      translationEn: "You (pl.) went",
      explanation: "Passé accompli 2e personne du pluriel.",
      explanationEn: "Perfective past, 2nd person plural.",
      example: "Onon njahii to lekkol? (Vous êtes allé(e)s à l'école ?)",
      exampleEn: "Onon njahii to lekkol? (Did you (pl.) go to school?)"
    },
    'ɓe njahii': {
      translation: "Ils/Elles sont allé(e)s",
      translationEn: "They went",
      explanation: "Passé accompli 3e personne du pluriel.",
      explanationEn: "Perfective past, 3rd person plural.",
      example: "ɓe njahii to galle. (Ils/Elles sont allé(e)s à la maison.)",
      exampleEn: "ɓe njahii to galle. (They went home.)"
    },
    'Mi doon yaha': {
      translation: "J'étais en train d'aller",
      translationEn: "I was going",
      explanation: "Passé progressif (imparfait). 'Doon' est l'auxiliaire d'imparfait indiquant une action en cours dans le passé.",
      explanationEn: "Past progressive (imperfect). 'Doon' is the imperfect auxiliary indicating an ongoing action in the past.",
      example: "Mi doon yaha so o noddi-am. (J'étais en train de partir quand il/elle m'a appelé(e).)",
      exampleEn: "Mi doon yaha so o noddi-am. (I was leaving when he/she called me.)"
    },
    'Mi daan yaha': {
      translation: "J'avais l'habitude d'aller",
      translationEn: "I used to go",
      explanation: "Passé habituel — action répétée révolue. Équivalent de 'used to' en anglais.",
      explanationEn: "Past habitual — a repeated action no longer occurring. Equivalent of 'used to' in English.",
      example: "Mi daan yaha to luumo kala wiɗto. (J'avais l'habitude d'aller au marché chaque semaine.)",
      exampleEn: "Mi daan yaha to luumo kala wiɗto. (I used to go to the market every week.)"
    },
  },

  'Temps verbaux — Futur': {
    'Mi yehay': {
      translation: "J'irai",
      translationEn: "I will go",
      explanation: "Futur simple 1re personne du singulier. La racine verbale change de forme avec la voyelle finale.",
      explanationEn: "Simple future, 1st person singular. The verb root changes form with the final vowel.",
      example: "Mi yehay to luumo janngo. (J'irai au marché demain.)",
      exampleEn: "Mi yehay to luumo janngo. (I will go to the market tomorrow.)"
    },
    'A yehay': {
      translation: "Tu iras",
      translationEn: "You will go",
      explanation: "Futur simple 2e personne du singulier.",
      explanationEn: "Simple future, 2nd person singular.",
      example: "A yehay to lekkol janngo? (Tu iras à l'école demain ?)",
      exampleEn: "A yehay to lekkol janngo? (Will you go to school tomorrow?)"
    },
    'O yehay': {
      translation: "Il/Elle ira",
      translationEn: "He/She will go",
      explanation: "Futur simple 3e personne du singulier.",
      explanationEn: "Simple future, 3rd person singular.",
      example: "O yehay to galle janngo. (Il/Elle ira à la maison demain.)",
      exampleEn: "O yehay to galle janngo. (He/She will go home tomorrow.)"
    },
    'Minen njehay': {
      translation: "Nous irons",
      translationEn: "We will go",
      explanation: "Futur simple 1re personne du pluriel.",
      explanationEn: "Simple future, 1st person plural.",
      example: "Minen njehay to luumo janngo. (Nous irons au marché demain.)",
      exampleEn: "Minen njehay to luumo janngo. (We will go to the market tomorrow.)"
    },
    'Onon njehay': {
      translation: "Vous irez",
      translationEn: "You (pl.) will go",
      explanation: "Futur simple 2e personne du pluriel.",
      explanationEn: "Simple future, 2nd person plural.",
      example: "Onon njehay to lekkol janngo? (Vous irez à l'école demain ?)",
      exampleEn: "Onon njehay to lekkol janngo? (Will you (pl.) go to school tomorrow?)"
    },
    'ɓe njehay': {
      translation: "Ils/Elles iront",
      translationEn: "They will go",
      explanation: "Futur simple 3e personne du pluriel.",
      explanationEn: "Simple future, 3rd person plural.",
      example: "ɓe njehay to galle janngo. (Ils/Elles iront à la maison demain.)",
      exampleEn: "ɓe njehay to galle janngo. (They will go home tomorrow.)"
    },
    'So mi amii sahaa': {
      translation: "Si j'ai le temps [conditionnel]",
      translationEn: "If I have time [conditional]",
      explanation: "Construction conditionnelle avec 'so' — exprime une hypothèse présente ou future.",
      explanationEn: "Conditional construction with 'so' — expresses a present or future hypothesis.",
      example: "So mi amii sahaa, mi yehay. (Si j'ai le temps, j'irai.)",
      exampleEn: "So mi amii sahaa, mi yehay. (If I have time, I will go.)"
    },
  },

  'Temps verbaux — Impératif': {
    'Yahdu!': {
      translation: "Va ! (singulier)",
      translationEn: "Go! (singular)",
      explanation: "Impératif 2e personne du singulier. Le verbe prend une forme spéciale à l'impératif.",
      explanationEn: "Imperative, 2nd person singular. The verb takes a special form in the imperative.",
      example: "Yahdu to lekkol! (Va à l'école !)",
      exampleEn: "Yahdu to lekkol! (Go to school!)"
    },
    'Njahon!': {
      translation: "Allez ! (pluriel)",
      translationEn: "Go! (plural)",
      explanation: "Impératif 2e personne du pluriel. Le préfixe 'nj-' marque la nasalisation au pluriel.",
      explanationEn: "Imperative, 2nd person plural. The prefix 'nj-' marks nasalization in the plural.",
      example: "Njahon to luumo! (Allez au marché !)",
      exampleEn: "Njahon to luumo! (Go to the market!)"
    },
    'Hoto yahdu!': {
      translation: "Ne va pas ! (singulier)",
      translationEn: "Don't go! (singular)",
      explanation: "Impératif négatif singulier. 'Hoto' est le marqueur d'interdiction à la 2e personne du singulier.",
      explanationEn: "Negative imperative, singular. 'Hoto' is the prohibition marker for the 2nd person singular.",
      example: "Hoto yahdu ɗoon! (Ne va pas là-bas !)",
      exampleEn: "Hoto yahdu ɗoon! (Don't go there!)"
    },
    'Hoto njahon!': {
      translation: "N'allez pas ! (pluriel)",
      translationEn: "Don't go! (plural)",
      explanation: "Impératif négatif pluriel avec 'hoto'.",
      explanationEn: "Negative imperative, plural, with 'hoto'.",
      example: "Hoto njahon faa! (N'allez pas là !)",
      exampleEn: "Hoto njahon faa! (Don't go there!)"
    },
    'Rokku-am!': {
      translation: "Donne-moi !",
      translationEn: "Give me!",
      explanation: "Impératif du verbe 'rokka' (donner) avec suffixe objet -am (me).",
      explanationEn: "Imperative of the verb 'rokka' (to give) with the object suffix -am (me).",
      example: "Rokku-am ndiyam! (Donne-moi de l'eau !)",
      exampleEn: "Rokku-am ndiyam! (Give me water!)"
    },
    'Wadu jooni!': {
      translation: "Fais-le maintenant !",
      translationEn: "Do it now!",
      explanation: "Impératif de 'waɗa' (faire) avec adverbe 'jooni' (maintenant).",
      explanationEn: "Imperative of 'waɗa' (to do) with the adverb 'jooni' (now).",
      example: "Wadu jooni, tawi naatii. (Fais-le maintenant, car il fait déjà sombre.)",
      exampleEn: "Wadu jooni, tawi naatii. (Do it now, because it's already getting dark.)"
    },
  },

  'Négation': {
    'Mi yahaa': {
      translation: "Je ne vais pas",
      translationEn: "I am not going",
      explanation: "Négation du présent 1re personne. Le suffixe '-aa' marque la négation du présent habituel.",
      explanationEn: "Negation of the present, 1st person. The suffix '-aa' marks negation of the habitual present.",
      example: "Mi yahaa to luumo hannde. (Je ne vais pas au marché aujourd'hui.)",
      exampleEn: "Mi yahaa to luumo hannde. (I am not going to the market today.)"
    },
    'A yahaa': {
      translation: "Tu ne vas pas",
      translationEn: "You are not going",
      explanation: "Négation du présent 2e personne du singulier.",
      explanationEn: "Negation of the present, 2nd person singular.",
      example: "A yahaa to lekkol? (Tu ne vas pas à l'école ?)",
      exampleEn: "A yahaa to lekkol? (Aren't you going to school?)"
    },
    'O yahaa': {
      translation: "Il/Elle ne va pas",
      translationEn: "He/She is not going",
      explanation: "Négation du présent 3e personne du singulier.",
      explanationEn: "Negation of the present, 3rd person singular.",
      example: "O yahaa to galle. (Il/Elle ne va pas à la maison.)",
      exampleEn: "O yahaa to galle. (He/She is not going home.)"
    },
    'Mi yahiino': {
      translation: "Je ne suis pas allé(e)",
      translationEn: "I did not go",
      explanation: "Négation du passé accompli 1re personne du singulier.",
      explanationEn: "Negation of the perfective past, 1st person singular.",
      example: "Mi yahiino to féete. (Je ne suis pas allé(e) à la fête.)",
      exampleEn: "Mi yahiino to féete. (I did not go to the party.)"
    },
    'Mi yehayaa': {
      translation: "Je n'irai pas",
      translationEn: "I will not go",
      explanation: "Négation du futur 1re personne du singulier. Le suffixe '-aa' s'ajoute à la forme future.",
      explanationEn: "Negation of the future, 1st person singular. The suffix '-aa' is added to the future form.",
      example: "Mi yehayaa hannde. (Je n'irai pas aujourd'hui.)",
      exampleEn: "Mi yehayaa hannde. (I will not go today.)"
    },
    'O anndiaa': {
      translation: "Il/Elle ne sait pas",
      translationEn: "He/She does not know",
      explanation: "Négation du verbe 'anndi' (savoir) à la 3e personne du singulier.",
      explanationEn: "Negation of the verb 'anndi' (to know) in the 3rd person singular.",
      example: "O anndiaa hol ko ɓe waɗata. (Il/Elle ne sait pas ce qu'ils/elles font.)",
      exampleEn: "O anndiaa hol ko ɓe waɗata. (He/She doesn't know what they are doing.)"
    },
  },

  'Questions': {
    'Ko honɗum?': {
      translation: "Quoi ? / Qu'est-ce que ?",
      translationEn: "What?",
      explanation: "'Ko honɗum' interroge sur une chose ou un objet. 'Ko' est la copule, 'honɗum' est le pronom interrogatif neutre.",
      explanationEn: "'Ko honɗum' asks about a thing or object. 'Ko' is the copula, 'honɗum' is the neutral interrogative pronoun.",
      example: "Ko honɗum mbaadiɗaa? (Qu'est-ce que tu cherches ?)",
      exampleEn: "Ko honɗum mbaadiɗaa? (What are you looking for?)"
    },
    'Hommbo?': {
      translation: "Qui ?",
      translationEn: "Who?",
      explanation: "'Hommbo' interroge sur une personne au singulier.",
      explanationEn: "'Hommbo' asks about a person in the singular.",
      example: "Hommbo wii nii? (Qui a dit ça ?)",
      exampleEn: "Hommbo wii nii? (Who said that?)",
      audio: "Ff-Hommbo"
    },
    'Honto?': {
      translation: "Où ?",
      translationEn: "Where?",
      explanation: "'Honto' interroge sur un lieu ou une direction.",
      explanationEn: "'Honto' asks about a place or a direction.",
      example: "Honto mbaadiɗaa? (Où vas-tu ?)",
      exampleEn: "Honto mbaadiɗaa? (Where are you going?)",
      audio: "Ff-Honto"
    },
    'Honnde?': {
      translation: "Quand ?",
      translationEn: "When?",
      explanation: "'Honnde' interroge sur le moment d'une action.",
      explanationEn: "'Honnde' asks about the time of an action.",
      example: "Honnde ngaran-daa? (Quand est-ce que tu arrives ?)",
      exampleEn: "Honnde ngaran-daa? (When are you arriving?)",
      audio: "Ff-Honnde"
    },
    'Honno?': {
      translation: "Comment ?",
      translationEn: "How?",
      explanation: "'Honno' interroge sur la manière. Aussi utilisé pour les salutations : 'Honno mbaadiɗaa ?' = Comment vas-tu ?",
      explanationEn: "'Honno' asks about manner. Also used as a greeting: 'Honno mbaadiɗaa?' = How are you?",
      example: "Honno mbaadiɗaa? (Comment vas-tu ?)",
      exampleEn: "Honno mbaadiɗaa? (How are you?)",
      audio: "Ff-Honno"
    },
    'Fii hondun?': {
      translation: "Pourquoi ?",
      translationEn: "Why?",
      explanation: "'Fii hondun' interroge sur la cause ou le motif d'une action.",
      explanationEn: "'Fii hondun' asks about the cause or reason for an action.",
      example: "Fii hondun yahaa? (Pourquoi tu ne vas pas ?)",
      exampleEn: "Fii hondun yahaa? (Why aren't you going?)",
      audio: "Ff-Fii_hondun"
    },
    'Noy?': {
      translation: "Combien ?",
      translationEn: "How much/many?",
      explanation: "'Noy' interroge sur une quantité ou un prix.",
      explanationEn: "'Noy' asks about a quantity or a price.",
      example: "Noy ceede waɗi? (Combien ça coûte ?)",
      exampleEn: "Noy ceede waɗi? (How much does it cost?)"
    },
    'Ndax...?': {
      translation: "Est-ce que... ?",
      translationEn: "Is it that...? (yes/no question marker)",
      explanation: "'Ndax' en tête de phrase transforme une affirmation en question fermée (oui/non).",
      explanationEn: "'Ndax' at the start of a sentence turns a statement into a closed yes/no question.",
      example: "Ndax ngaran-daa démb? (Est-ce que tu es arrivé(e) hier ?)",
      exampleEn: "Ndax ngaran-daa démb? (Did you arrive yesterday?)"
    },
  },

  // ============================================================
  // UNITÉ 3 — PRÉPOSITIONS, ADJECTIFS, ADVERBES & CONJONCTIONS
  // ============================================================

  'Prépositions de lieu': {
    'To': {
      translation: "À, vers, dans",
      translationEn: "To, towards, in",
      explanation: "Préposition de lieu générale, indique la direction ou la position.",
      explanationEn: "General preposition of place, indicates direction or position.",
      example: "Mi yaha to luumo. (Je vais au marché.)",
      exampleEn: "Mi yaha to luumo. (I am going to the market.)"
    },
    'E': {
      translation: "Dans, sur, en",
      translationEn: "In, on, at",
      explanation: "Préposition de position, indique l'intérieur ou la surface.",
      explanationEn: "Preposition of position, indicates the interior or the surface.",
      example: "Miɗo woni e suudu. (Je suis dans la chambre.)",
      exampleEn: "Miɗo woni e suudu. (I am in the room.)"
    },
    'Nder': {
      translation: "À l'intérieur de",
      translationEn: "Inside of",
      explanation: "Indique l'intériorité avec plus de précision que 'e'.",
      explanationEn: "Indicates interiority more precisely than 'e'.",
      example: "Ngesa woni nder ladde. (Le champ est à l'intérieur de la brousse.)",
      exampleEn: "Ngesa woni nder ladde. (The field is inside the bush.)"
    },
    'Dow': {
      translation: "Sur, au-dessus de",
      translationEn: "On, above",
      explanation: "Indique une position supérieure.",
      explanationEn: "Indicates a higher position.",
      example: "Teg ko dow taabal. (Mets-le sur la table.)",
      exampleEn: "Teg ko dow taabal. (Put it on the table.)"
    },
    'Ley': {
      translation: "Sous, en dessous de",
      translationEn: "Under, beneath",
      explanation: "Indique une position inférieure.",
      explanationEn: "Indicates a lower position.",
      example: "Ngaari woni ley garab. (Le bœuf est sous l'arbre.)",
      exampleEn: "Ngaari woni ley garab. (The ox is under the tree.)"
    },
    'Juuɗe': {
      translation: "À côté de, près de",
      translationEn: "Next to, near",
      explanation: "Indique la proximité spatiale.",
      explanationEn: "Indicates spatial proximity.",
      example: "Toog juuɗe am. (Assieds-toi à côté de moi.)",
      exampleEn: "Toog juuɗe am. (Sit next to me.)"
    },
    'Yeeso': {
      translation: "Devant",
      translationEn: "In front of",
      explanation: "Indique une position antérieure ou frontale.",
      explanationEn: "Indicates a forward or frontal position.",
      example: "Taxaw yeeso suudu. (Reste debout devant la maison.)",
      exampleEn: "Taxaw yeeso suudu. (Stand in front of the house.)"
    },
    'Caggal': {
      translation: "Derrière",
      translationEn: "Behind",
      explanation: "Indique une position postérieure.",
      explanationEn: "Indicates a rear position.",
      example: "O woni caggal garab gi. (Il/Elle est derrière l'arbre.)",
      exampleEn: "O woni caggal garab gi. (He/She is behind the tree.)"
    },
    'Haa': {
      translation: "Jusqu'à",
      translationEn: "Until, up to",
      explanation: "Indique une limite dans le temps ou l'espace.",
      explanationEn: "Indicates a limit in time or space.",
      example: "Yahdu haa lekkol. (Va jusqu'à l'école.)",
      exampleEn: "Yahdu haa lekkol. (Go as far as the school.)"
    },
    'Doo': {
      translation: "Ici",
      translationEn: "Here",
      explanation: "Adverbe de lieu indiquant la proximité immédiate du locuteur.",
      explanationEn: "Adverb of place indicating the immediate proximity of the speaker.",
      example: "Aru doo. (Viens ici.)",
      exampleEn: "Aru doo. (Come here.)"
    },
    'ɗoon': {
      translation: "Là, là-bas",
      translationEn: "There, over there",
      explanation: "Adverbe de lieu indiquant un endroit éloigné du locuteur.",
      explanationEn: "Adverb of place indicating a location far from the speaker.",
      example: "Dem ɗoon. (Va là-bas.)",
      exampleEn: "Dem ɗoon. (Go there.)"
    },
    'E daande': {
      translation: "À côté, près",
      translationEn: "Beside, near",
      explanation: "Locution prépositionnelle de proximité immédiate.",
      explanationEn: "Prepositional phrase of immediate proximity.",
      example: "O woni e daande am. (Il/Elle est à côté de moi.)",
      exampleEn: "O woni e daande am. (He/She is beside me.)"
    },
  },

  'Prépositions de temps et de relation': {
    'Caggal': {
      translation: "Après",
      translationEn: "After",
      explanation: "Indique une action postérieure à une autre.",
      explanationEn: "Indicates an action that follows another.",
      example: "Caggal ñaamde, mi yehay. (Après avoir mangé, j'irai.)",
      exampleEn: "Caggal ñaamde, mi yehay. (After eating, I will go.)"
    },
    'Yeeso': {
      translation: "Avant",
      translationEn: "Before",
      explanation: "Indique une action antérieure à une autre.",
      explanationEn: "Indicates an action that precedes another.",
      example: "Yeeso yahde, wiydu-am. (Avant de partir, dis-le-moi.)",
      exampleEn: "Yeeso yahde, wiydu-am. (Before leaving, tell me.)"
    },
    'Haa': {
      translation: "Jusqu'à",
      translationEn: "Until",
      explanation: "Indique une limite dans le temps.",
      explanationEn: "Indicates a limit in time.",
      example: "Xaar haa janngo. (Attends jusqu'à demain.)",
      exampleEn: "Xaar haa janngo. (Wait until tomorrow.)"
    },
    'Ko': {
      translation: "Avec",
      translationEn: "With",
      explanation: "Préposition d'accompagnement, exprime la compagnie.",
      explanationEn: "Preposition of accompaniment, expresses company.",
      example: "Mi yaha ko aan. (Je vais avec toi.)",
      exampleEn: "Mi yaha ko aan. (I am going with you.)"
    },
    'Ngir': {
      translation: "Pour, afin de",
      translationEn: "For, in order to",
      explanation: "Indique le but ou la finalité d'une action.",
      explanationEn: "Indicates the purpose or goal of an action.",
      example: "Mi waɗii ko ngir maa. (Je l'ai fait pour toi.)",
      exampleEn: "Mi waɗii ko ngir maa. (I did it for you.)"
    },
    'Ndaw': {
      translation: "Depuis",
      translationEn: "Since",
      explanation: "Indique le point de départ dans le temps.",
      explanationEn: "Indicates the starting point in time.",
      example: "Ndaw subaka, miɗo liggoo. (Depuis ce matin, je travaille.)",
      exampleEn: "Ndaw subaka, miɗo liggoo. (Since this morning, I have been working.)"
    },
    'E sahaa': {
      translation: "Pendant",
      translationEn: "During",
      explanation: "Indique une durée.",
      explanationEn: "Indicates a duration.",
      example: "E sahaa lewru, mi ɗanngii ɗoo. (Pendant un mois, j'ai séjourné ici.)",
      exampleEn: "E sahaa lewru, mi ɗanngii ɗoo. (For a month, I stayed here.)"
    },
    'Ni': {
      translation: "Comme, de la même façon que",
      translationEn: "Like, in the same way as",
      explanation: "Indique une comparaison ou une ressemblance.",
      explanationEn: "Indicates a comparison or resemblance.",
      example: "Dox ni puccu. (Cours comme un cheval.)",
      exampleEn: "Dox ni puccu. (Run like a horse.)"
    },
  },

  'Adjectifs — Apparence physique': {
    'Moƴƴo': {
      translation: "Beau, belle, bon(ne)",
      translationEn: "Beautiful, good",
      explanation: "Adjectif général positif, s'accorde avec la classe nominale du nom qu'il qualifie.",
      explanationEn: "General positive adjective, agrees with the noun class of the noun it qualifies.",
      example: "Debbo moƴƴo. (Une belle femme.) — Gorko moƴƴo. (Un bel homme.)",
      exampleEn: "Debbo moƴƴo. (A beautiful woman.) — Gorko moƴƴo. (A handsome man.)"
    },
    'Bonngo': {
      translation: "Mauvais, laid",
      translationEn: "Bad, ugly",
      explanation: "Adjectif général négatif, opposé de moƴƴo.",
      explanationEn: "General negative adjective, opposite of moƴƴo.",
      example: "Golle bonngo. (Un mauvais travail.)",
      exampleEn: "Golle bonngo. (A bad job.)"
    },
    'Mawɗo': {
      translation: "Grand, gros",
      translationEn: "Big, large",
      explanation: "Adjectif de taille, indique une grande dimension ou une grande importance.",
      explanationEn: "Adjective of size, indicates a large dimension or great importance.",
      example: "Suudu mawɗo. (Une grande chambre.)",
      exampleEn: "Suudu mawɗo. (A large room.)"
    },
    'Pamaro': {
      translation: "Petit, petite",
      translationEn: "Small",
      explanation: "Adjectif de taille, indique une petite dimension.",
      explanationEn: "Adjective of size, indicates a small dimension.",
      example: "Cukalel pamaro. (Un petit enfant.)",
      exampleEn: "Cukalel pamaro. (A small child.)"
    },
    'ɗukkere': {
      translation: "Rapide, léger",
      translationEn: "Fast, light",
      explanation: "Adjectif de vitesse ou de légèreté.",
      explanationEn: "Adjective of speed or lightness.",
      example: "Puccu ɗukkere. (Un cheval rapide.)",
      exampleEn: "Puccu ɗukkere. (A fast horse.)"
    },
    'Semtinɗo': {
      translation: "Svelte, mince, élancé",
      translationEn: "Slender, slim",
      explanation: "Décrit une personne élancée et fine.",
      explanationEn: "Describes a slender, slim person.",
      example: "Debbo semtinɗo. (Une femme svelte.)",
      exampleEn: "Debbo semtinɗo. (A slender woman.)"
    },
    'Teewɗo': {
      translation: "Corpulent, robuste",
      translationEn: "Stout, sturdy",
      explanation: "Décrit une personne de forte constitution.",
      explanationEn: "Describes a person of strong build.",
      example: "Gorko teewɗo. (Un homme corpulent.)",
      exampleEn: "Gorko teewɗo. (A stout man.)"
    },
    'Juuɗo': {
      translation: "Long, grand (stature)",
      translationEn: "Tall (stature)",
      explanation: "Décrit une grande longueur ou une grande stature.",
      explanationEn: "Describes great length or tall stature.",
      example: "Laawol juuɗo. (Un long chemin.)",
      exampleEn: "Laawol juuɗo. (A long path.)"
    },
  },

  'Adjectifs — Caractère': {
    'ɗoole': {
      translation: "Fort, courageux",
      translationEn: "Strong, brave",
      explanation: "Décrit la force physique ou la bravoure morale.",
      explanationEn: "Describes physical strength or moral bravery.",
      example: "Neɗɗo ɗoole. (Un homme fort/courageux.)",
      exampleEn: "Neɗɗo ɗoole. (A strong/brave man.)",
      audio: "Ff-Doole"
    },
    'Tindinɗo': {
      translation: "Intelligent, sage",
      translationEn: "Intelligent, wise",
      explanation: "Décrit une personne perspicace et sage.",
      explanationEn: "Describes a perceptive and wise person.",
      example: "Jangirɗo tindinɗo. (Un étudiant intelligent.)",
      exampleEn: "Jangirɗo tindinɗo. (An intelligent student.)"
    },
    'Muɗɗo': {
      translation: "Patient, calme",
      translationEn: "Patient, calm",
      explanation: "Décrit une personne qui sait attendre et garder son calme.",
      explanationEn: "Describes a person who knows how to wait and stay calm.",
      example: "Jangirde muɗɗo. (Un/Une enseignant(e) patient(e).)",
      exampleEn: "Jangirde muɗɗo. (A patient teacher.)"
    },
    'Senndinɗo': {
      translation: "Généreux, charitable",
      translationEn: "Generous, charitable",
      explanation: "Décrit une personne qui aime donner et partager.",
      explanationEn: "Describes a person who likes to give and share.",
      example: "Debbo senndinɗo. (Une femme généreuse.)",
      exampleEn: "Debbo senndinɗo. (A generous woman.)"
    },
    'Goonga': {
      translation: "Honnête, sincère",
      translationEn: "Honest, sincere",
      explanation: "Décrit une personne sincère et droite.",
      explanationEn: "Describes a sincere and upright person.",
      example: "Gorko goonga. (Un homme honnête.)",
      exampleEn: "Gorko goonga. (An honest man.)"
    },
    'Neldindo': {
      translation: "Courageux, brave",
      translationEn: "Courageous, brave",
      explanation: "Décrit une personne qui affronte les difficultés sans peur.",
      explanationEn: "Describes a person who faces difficulties fearlessly.",
      example: "Dimo neldindo. (Un noble courageux.)",
      exampleEn: "Dimo neldindo. (A courageous noble.)"
    },
    'Feewnitinɗo': {
      translation: "Poli, bien élevé",
      translationEn: "Polite, well-mannered",
      explanation: "Décrit une personne aux bonnes manières et respectueuse.",
      explanationEn: "Describes a person with good manners who is respectful.",
      example: "Cukalel feewnitinɗo. (Un enfant bien élevé.)",
      exampleEn: "Cukalel feewnitinɗo. (A well-mannered child.)"
    },
    'Woraango': {
      translation: "Paresseux",
      translationEn: "Lazy",
      explanation: "Décrit un manque de motivation et d'effort.",
      explanationEn: "Describes a lack of motivation and effort.",
      example: "Jangirɗo woraango. (Un étudiant paresseux.)",
      exampleEn: "Jangirɗo woraango. (A lazy student.)"
    },
  },

  'Adjectifs — États et sensations': {
    'Tanggu': {
      translation: "Chaud",
      translationEn: "Hot",
      explanation: "Décrit la sensation de chaleur d'un objet ou de l'atmosphère.",
      explanationEn: "Describes the sensation of heat of an object or the atmosphere.",
      example: "Ndiyam tanggu. (L'eau est chaude.)",
      exampleEn: "Ndiyam tanggu. (The water is hot.)"
    },
    'Seddude': {
      translation: "Froid, frais",
      translationEn: "Cold, cool",
      explanation: "Décrit la sensation de fraîcheur ou de froid.",
      explanationEn: "Describes the sensation of coolness or cold.",
      example: "Ceedu seddude. (Le temps est frais.)",
      exampleEn: "Ceedu seddude. (The weather is cool.)"
    },
    'Laɓɓude': {
      translation: "Doux, délicieux, agréable",
      translationEn: "Sweet, delicious, pleasant",
      explanation: "Décrit quelque chose d'agréable au goût, à l'ouïe ou au toucher.",
      explanationEn: "Describes something pleasant to taste, hear, or touch.",
      example: "Ñaamdu laɓɓude. (La nourriture est délicieuse.)",
      exampleEn: "Ñaamdu laɓɓude. (The food is delicious.)"
    },
    'Teddude': {
      translation: "Lourd",
      translationEn: "Heavy",
      explanation: "Décrit un poids important.",
      explanationEn: "Describes a significant weight.",
      example: "Cargaaji teddude. (Les bagages sont lourds.)",
      exampleEn: "Cargaaji teddude. (The luggage is heavy.)"
    },
    'Faayode': {
      translation: "Propre, net",
      translationEn: "Clean, tidy",
      explanation: "Décrit quelque chose de propre et sans tache.",
      explanationEn: "Describes something clean and spotless.",
      example: "Nguruungu faayode. (La chambre est propre.)",
      exampleEn: "Nguruungu faayode. (The room is clean.)"
    },
    'Miñinɗo': {
      translation: "Sale, souillé",
      translationEn: "Dirty, soiled",
      explanation: "Opposé de faayode — décrit quelque chose de sale.",
      explanationEn: "Opposite of faayode — describes something dirty.",
      example: "Karaba miñinɗo. (Des habits sales.)",
      exampleEn: "Karaba miñinɗo. (Dirty clothes.)"
    },
    'Heblude': {
      translation: "Épuisé, fatigué",
      translationEn: "Exhausted, tired",
      explanation: "Décrit un état de fatigue physique ou morale.",
      explanationEn: "Describes a state of physical or mental fatigue.",
      example: "Miɗo hebla. (Je suis fatigué(e).)",
      exampleEn: "Miɗo hebla. (I am tired.)"
    },
    'Anndinɗo': {
      translation: "Affamé",
      translationEn: "Hungry",
      explanation: "Décrit l'état d'avoir faim.",
      explanationEn: "Describes the state of being hungry.",
      example: "Mi anndinɗo. (J'ai faim.)",
      exampleEn: "Mi anndinɗo. (I am hungry.)"
    },
  },

  'Adjectifs — Quantité et jugement': {
    'Keewɓe / Keewɗi': {
      translation: "Nombreux, beaucoup",
      translationEn: "Many, numerous",
      explanation: "Décrit une grande quantité. La forme varie selon la classe nominale du nom.",
      explanationEn: "Describes a large quantity. The form varies according to the noun class.",
      example: "Neɗɗaaɓe keewɓe. (Des gens nombreux.) — Hoɗorde keewɗe. (Beaucoup de maisons.)",
      exampleEn: "Neɗɗaaɓe keewɓe. (Many people.) — Hoɗorde keewɗe. (Many houses.)"
    },
    'Seeɗa': {
      translation: "Peu, rare",
      translationEn: "Little, few",
      explanation: "Décrit une faible quantité.",
      explanationEn: "Describes a small quantity.",
      example: "Ndiyam seeɗa. (Peu d'eau.)",
      exampleEn: "Ndiyam seeɗa. (Little water.)"
    },
    'Waylitaare': {
      translation: "Facile, simple",
      translationEn: "Easy, simple",
      explanation: "Décrit quelque chose d'aisé à réaliser.",
      explanationEn: "Describes something easy to accomplish.",
      example: "Liggol waylitaare. (Un travail facile.)",
      exampleEn: "Liggol waylitaare. (An easy job.)"
    },
    'Jafngo': {
      translation: "Difficile, ardu",
      translationEn: "Difficult, arduous",
      explanation: "Décrit quelque chose de compliqué à accomplir.",
      explanationEn: "Describes something complicated to accomplish.",
      example: "Seedantaare jafngo. (Un examen difficile.)",
      exampleEn: "Seedantaare jafngo. (A difficult exam.)"
    },
    'Bees': {
      translation: "Nouveau, neuf",
      translationEn: "New",
      explanation: "Décrit quelque chose de récent ou qui n'a pas encore servi.",
      explanationEn: "Describes something recent or not yet used.",
      example: "Daraja bees. (Un pont neuf.)",
      exampleEn: "Daraja bees. (A new bridge.)"
    },
    'Ɓooyngo': {
      translation: "Vieux, ancien",
      translationEn: "Old",
      explanation: "Décrit quelque chose d'ancien ou de vieilli.",
      explanationEn: "Describes something old or worn.",
      example: "Jaango ɓooyngo. (Un vieux pagne.)",
      exampleEn: "Jaango ɓooyngo. (An old wrap.)"
    },
    'Timmungo': {
      translation: "Complet, entier",
      translationEn: "Complete, whole",
      explanation: "Décrit quelque chose de complet, sans manque ni défaut.",
      explanationEn: "Describes something complete, with no lack or flaw.",
      example: "Liggol timmungo. (Un travail complet.)",
      exampleEn: "Liggol timmungo. (A complete job.)"
    },
  },

  'Conjonctions': {
    'E': {
      translation: "Et (coordination)",
      translationEn: "And (coordination)",
      explanation: "'E' relie deux noms ou groupes nominaux. Pour relier deux propositions, on préfère la juxtaposition.",
      explanationEn: "'E' links two nouns or noun phrases. To link two clauses, juxtaposition is preferred.",
      example: "Gorko e debbo njahii. (L'homme et la femme sont partis.)",
      exampleEn: "Gorko e debbo njahii. (The man and the woman left.)"
    },
    'Kono': {
      translation: "Mais",
      translationEn: "But",
      explanation: "'Kono' introduit une opposition ou une restriction.",
      explanationEn: "'Kono' introduces an opposition or a restriction.",
      example: "Mi baawiɗo yaha, kono mi woniino. (Je peux y aller, mais je n'y étais pas.)",
      exampleEn: "Mi baawiɗo yaha, kono mi woniino. (I can go, but I wasn't there.)"
    },
    'Maa': {
      translation: "Ou",
      translationEn: "Or",
      explanation: "'Maa' introduit une alternative entre deux options.",
      explanationEn: "'Maa' introduces an alternative between two options.",
      example: "Yahdu lekkol maa luumo? (Tu vas à l'école ou au marché ?)",
      exampleEn: "Yahdu lekkol maa luumo? (Are you going to school or to the market?)"
    },
    'Ndaw': {
      translation: "Parce que, puisque",
      translationEn: "Because, since",
      explanation: "'Ndaw' introduit une proposition causale expliquant la raison d'une action.",
      explanationEn: "'Ndaw' introduces a causal clause explaining the reason for an action.",
      example: "Mi yahiino ndaw mi hebliino. (Je ne suis pas allé(e) parce que j'étais fatigué(e).)",
      exampleEn: "Mi yahiino ndaw mi hebliino. (I didn't go because I was tired.)"
    },
    'So': {
      translation: "Si (conditionnel)",
      translationEn: "If (conditional)",
      explanation: "'So' introduit une condition hypothétique au présent ou au futur.",
      explanationEn: "'So' introduces a hypothetical condition in the present or future.",
      example: "So mi amii sahaa, mi yehay. (Si j'ai le temps, j'irai.)",
      exampleEn: "So mi amii sahaa, mi yehay. (If I have time, I will go.)"
    },
    'Ko waɗi': {
      translation: "Donc, alors, c'est pourquoi",
      translationEn: "So, then, that's why",
      explanation: "'Ko waɗi' marque la conséquence logique d'une action ou d'un état.",
      explanationEn: "'Ko waɗi' marks the logical consequence of an action or state.",
      example: "Mi yahii, ko waɗi mi anndinii. (Je suis allé(e), donc j'ai appris.)",
      exampleEn: "Mi yahii, ko waɗi mi anndinii. (I went, so I learned.)"
    },
    'Haa tuma': {
      translation: "Jusqu'à ce que",
      translationEn: "Until",
      explanation: "Exprime une limite temporelle — l'action se poursuit jusqu'à un événement.",
      explanationEn: "Expresses a temporal limit — the action continues until an event occurs.",
      example: "Liggoo haa tuma ɓe ngarti. (Travaille jusqu'à ce qu'ils/elles reviennent.)",
      exampleEn: "Liggoo haa tuma ɓe ngarti. (Work until they come back.)"
    },
    'Ko adii ko': {
      translation: "Avant que, avant de",
      translationEn: "Before",
      explanation: "Exprime l'antériorité d'une action par rapport à une autre.",
      explanationEn: "Expresses the precedence of one action over another.",
      example: "Wadu ko adii ko yahde. (Fais-le avant de partir.)",
      exampleEn: "Wadu ko adii ko yahde. (Do it before leaving.)"
    },
  },

  'Adverbes': {
    'Tawi': {
      translation: "Vraiment, certainement",
      translationEn: "Really, certainly",
      explanation: "'Tawi' renforce une affirmation et insiste sur la vérité d'un fait.",
      explanationEn: "'Tawi' reinforces a statement and emphasizes the truth of a fact.",
      example: "O baawii tawi. (Il/Elle est vraiment capable.)",
      exampleEn: "O baawii tawi. (He/She is really capable.)"
    },
    'Tan': {
      translation: "Seulement, juste",
      translationEn: "Only, just",
      explanation: "'Tan' est un restrictif qui limite la portée du terme précédent.",
      explanationEn: "'Tan' is a restrictive word limiting the scope of the preceding term.",
      example: "Mi yahii tan. (Je suis juste allé(e) — et rien d'autre.)",
      exampleEn: "Mi yahii tan. (I just went — and nothing more.)"
    },
    'Jooni': {
      translation: "Maintenant, tout de suite",
      translationEn: "Now, right away",
      explanation: "'Jooni' situe l'action dans le moment présent ou immédiat.",
      explanationEn: "'Jooni' places the action in the present or immediate moment.",
      example: "Aru jooni! (Viens tout de suite !)",
      exampleEn: "Aru jooni! (Come right away!)"
    },
    'Hannde': {
      translation: "Aujourd'hui",
      translationEn: "Today",
      explanation: "Adverbe de temps situant l'action dans la journée en cours.",
      explanationEn: "Adverb of time placing the action in the current day.",
      example: "Hannde laa ko yeɗii. (C'est aujourd'hui que je l'ai vu.)",
      exampleEn: "Hannde laa ko yeɗii. (It is today that I saw him/her.)"
    },
    'Démb': {
      translation: "Hier",
      translationEn: "Yesterday",
      explanation: "Adverbe de temps désignant le jour précédent.",
      explanationEn: "Adverb of time designating the previous day.",
      example: "Mi yahii démb. (Je suis allé(e) hier.)",
      exampleEn: "Mi yahii démb. (I went yesterday.)"
    },
    'Janngo': {
      translation: "Demain",
      translationEn: "Tomorrow",
      explanation: "Adverbe de temps désignant le jour suivant.",
      explanationEn: "Adverb of time designating the following day.",
      example: "Mi yehay janngo. (J'irai demain.)",
      exampleEn: "Mi yehay janngo. (I will go tomorrow.)"
    },
    'Seeɗa seeɗa': {
      translation: "Doucement, peu à peu",
      translationEn: "Slowly, little by little",
      explanation: "Adverbe de manière exprimant la progressivité ou la lenteur.",
      explanationEn: "Adverb of manner expressing gradualness or slowness.",
      example: "Jang seeɗa seeɗa. (Apprends doucement, pas à pas.)",
      exampleEn: "Jang seeɗa seeɗa. (Learn slowly, step by step.)"
    },
    'Tellen': {
      translation: "Environ, approximativement",
      translationEn: "About, approximately",
      explanation: "Indique une quantité ou un moment approximatif.",
      explanationEn: "Indicates an approximate quantity or time.",
      example: "Ko tellen guluuji sappo e jowi. (C'est environ quinze heures.)",
      exampleEn: "Ko tellen guluuji sappo e jowi. (It's about fifteen o'clock / 3pm.)"
    },
    'No gasa': {
      translation: "Peut-être",
      translationEn: "Maybe",
      explanation: "Exprime le doute ou la probabilité.",
      explanationEn: "Expresses doubt or probability.",
      example: "No gasa o yehay janngo. (Il/Elle ira peut-être demain.)",
      exampleEn: "No gasa o yehay janngo. (He/She might go tomorrow.)"
    },
    'Haapoma': {
      translation: "Jamais",
      translationEn: "Never",
      explanation: "Adverbe de fréquence totalement négatif.",
      explanationEn: "Adverb of frequency, entirely negative.",
      example: "Haapoma mi yahaa faa. (Je n'irai jamais là-bas.)",
      exampleEn: "Haapoma mi yahaa faa. (I will never go there.)"
    },
  },

};

export default grammaire;

export {};
